import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import TypeDocumentRow from './TypeDocumentRow';
import _ from 'lodash';
import { PsTable } from '../../shared/components/table/PsTable';

export default class TypeDocumentsTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th>{I18nUtils.tr('TR_NOMBRE_TIPO_DE_DOCUMENTO')}</th>
                <th>{I18nUtils.tr('TR_TIPO_DE_ADJUNTO_TITLE')}</th>
                <th>{I18nUtils.tr('TR_CADUCA')}</th>
                <th>{I18nUtils.tr('TR_ACCESO_FICHA')}</th>
            </tr>
        );
    }

    render() {
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;

        }

        return (
            <PsTable headings={this.renderHead()}>
                {
                    _.map(this.props.data, object =>
                        <TypeDocumentRow key={object.id} typedocument={object} />,
                    )
                }
            </PsTable>
        );
    }

}

TypeDocumentsTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
};
TypeDocumentsTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/TypeDocumentsTable.jsx